export const AUTHORIZED_APPS_PAGE_SIZE = 25
